import React from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import {
  AdminPricingPlan,
  AdminReferralProgram,
  Billing,
  ConfigurationTabs,
  CustomizeEmbedCode,
  EditUser,
  ListUser,
  LoginForm,
  OrganizationsComponent,
  PageNotFound,
  PaymentSuccess,
  PricingPlans,
  AddUser,
  Profile,
  ResetPassword,
  UsersAssistant,
  PrompotUsersList,
  PromptList,
  ReferralProgram,
  SignUp,
  Subscribers,
  // OrganizationsComponent,
  TeamList,
  TemplateList,
  TrackUsageComponent,
  Verification,
  AssistantsList,
  AssistantsChatPage,
  ChatPage,
  AssistantFileDownloadPage, 
  LinkedInCallback,
  AccountReview
} from "./Pages";



import Templates from "./component/Prompt/Templates";
import Layout from "./Pages/Layout";
import OrganizationalAdminRoutes from "./component/RoutesData/OrganizationalAdminRoutes";
import SubscriptionsStats from "./Pages/SuperAdmin/SubscriptionsStats";

import AssistantLayout from "./Pages/Layout/AssistantLayout";
import Configration from "./Pages/configration";
import SuperAdminRoutes from "./component/RoutesData/SuperAdminRoutes";
import TrackUsage from "./Pages/SuperAdmin/TrackUsage/TrackUsage";
import PublicAssistant from "./Pages/ExploreGPTs";
import ProtectedRoutes from "./component/ProtectedRoute/ProtectedRoute";
import AssistantTypeList from "./Pages/AssistantType/index";
import IndustryTypeList from "./Pages/IndustryType/index";
import KnowledgeBase from "./Pages/KnowledgeBase";
import TaskCommands from "./Pages/SuperAdmin/TaskCommands/TaskCommands";
import GlobalLayout from "./Global";

import MainLayout from "./Pages/Layout/MainLayout";
import { IntegrateApplications } from "./component/IntegrateApplications/IntegrateApplications";
import ConnectionWithWorkboard from "./Pages/configration/ConnectionWithWorkboard";
import AuthorizeEmailDomain from "./Pages/AuthorizeEmailDomain/AuthorizeEmailDomain";
import AuthCheck from "./component/AuthCheck/AuthCheck";
import useCheckDeployment from "./Utility/checkDeployment";
import { TourProvider } from "./Utility/TourContext";
import AdminApprovalPage from "./Utility/AdminApprovalPage";
import IndustryLanding from "./Pages/Industry/IndustryLanding";
import CompanyInfo from "./Pages/CompanyInfo";
import TermsAndCondition from "./Pages/TermsAndConditions/TermsAndConditions";
import SecurityDataPolicy from "./Pages/SecurityDataPolicy/SecurityDataPolicy";
import Subscriptions from "./component/layout/NewSidebar/Subscriptions";
 
function App() {
  useCheckDeployment();
  const location = useLocation();
  const userId = localStorage.getItem("userId");

  // Redirect to chat page if the user is on the root path
  if (location.pathname === "/") {
    return <Navigate to="/chat" />;
  }

  return (
    <>
    <TourProvider>
      <Routes>
        <Route path="/login" element={
          <AuthCheck>
            <LoginForm />
          </AuthCheck>
        } />
        <Route path="signup" element={<SignUp />} />
        <Route path="terms-and-condition" element={<TermsAndCondition />} />
        <Route path="security-data-privacy" element={<SecurityDataPolicy />} />
        <Route path="verify/:id" element={<Verification />} />
        <Route path="account-under-review" element={<AccountReview />} />
        <Route path="passwordReset/:token/:id" element={<ResetPassword />} />
        <Route path="*" element={<PageNotFound />} />

   {/* For connecting workboard */}
      <Route path="ConnectionWithWorkboard" element={<ConnectionWithWorkboard />} /> 
      <Route path="/" element={<Layout />}>
        {/* <Route path="config/" element={<ConfigurationTabs />} /> */}
        <Route path="/profile" element={<Profile />} />
        <Route path="/users-agents" element={<UsersAssistant />} />
        <Route path="chat" element={<ChatPage />} />
        <Route path="chat/:thread_id" element={<ChatPage />} />
        <Route path="promptlist/" element={<PromptList />} />
        <Route path="promptlistview/:id" element={<PromptList />} />
        <Route path="promptuserview" element={<PrompotUsersList />} />
        <Route path="/knowledge-base" element={<KnowledgeBase />} /> 
        <Route path="/integrate-apps" element={<IntegrateApplications/>} /> 
        <Route path="/linkedin-callback" element={<LinkedInCallback />} />
        <Route path="/templates" element={<Templates />} />
        <Route path="/subscriptions" element={<Subscriptions />} />

          <Route element={<ProtectedRoutes />}>
            <Route path="agents/:assistant_id" element={<AssistantsChatPage />} />
            <Route path="agents/:assistant_id/:thread_id" element={<AssistantsChatPage />} />
          </Route>


        <Route path="/agent-types" element={<AssistantTypeList />} />
        <Route path="/industry-types" element={<IndustryTypeList />} />

        <Route path="/public-agent" element={<PublicAssistant />} />

        {/* Protected Routes of SuperAdmin */}
        <Route element={<SuperAdminRoutes />}>
          <Route path="/teams" element={<TeamList />} />
          <Route path="/config" element={<ConfigurationTabs />} />
          <Route path="/organizations" element={<OrganizationsComponent />} />
          <Route path="/config" element={<ConfigurationTabs />} />
          <Route path="/taskCommands" element={<TaskCommands />} />
          {/* [TODO : commenting for now, will be added later when organization functionality will be enabled ] */}
          {/* <Route path="/organizations" element={<OrganizationsComponent />} /> */}

          <Route path="users/" element={<ListUser />} />
          <Route path="users/add" element={<AddUser />} />
          <Route path="authorizeEmailDomain/" element={<AuthorizeEmailDomain/>}/>
          <Route path="users/edit/:id" element={<EditUser />} />

          <Route path="/templist" element={<TemplateList />} />
          <Route path="/teams" element={<TeamList />} />

          <Route path="/admin-pricing" element={<AdminPricingPlan />} />
            <Route path="/agentsList" element={<AssistantsList />} />
            <Route path="/trackUsage" element={<TrackUsageComponent />} />
            <Route path="/referral-program" element={<AdminReferralProgram />} />
            <Route path="/subscribers" element={<Subscribers />} />
            <Route path="/subscription-stats" element={<SubscriptionsStats />} />
            </Route>

          {/* Protected Routes of Organizational Admin */}
          <Route element={<OrganizationalAdminRoutes />}>
            <Route path="/trackUsageList" element={<TrackUsageComponent />} />
            <Route path="/allUsers" element={<ListUser />} />
            <Route path="/allTeams" element={<TeamList />} />
            <Route path="/allAssistantsList" element={<AssistantsList />} />
            <Route path="/pricing" element={<PricingPlans />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/invitation" element={<ReferralProgram />} />
            <Route path="/billing" element={<Billing />} />
          </Route>
        </Route>

      <Route path="assistants/download/:file_id" element={<AssistantFileDownloadPage />} />
        <Route path="/customize-embed-code/:assistantId" element={<CustomizeEmbedCode />} />

        <Route path="/admin/approve-reject-confirmation" element={<AdminApprovalPage />} />
        <Route path="/industry" element={<IndustryLanding/>} />
        <Route path="/company-info" element={<CompanyInfo/>} />


      </Routes>
      </TourProvider>
    </>
  );
}

export default App;
